import ApiService from "@/common/api.service";
import { FETCH_ROLLUP_FEES } from "./actions.type";
import {
    FETCH_START_ROLLUP_FEES,
    FETCH_END_ROLLUP_FEES
} from "./mutations.type";

const state = {
    rollupFees: [],
    isLoading: false,
    lastFetched: null
};

const getters = {
    rollupFees(state) {
        return state.rollupFees;
    },
    isLoadingRollupFees(state) {
        return state.isLoading;
    },
    // Get fee name by ID
    getRollupFeeName: (state) => (id) => {
        if (!id) return null;
        const feeId = typeof id === 'string' ? parseInt(id) : id;
        const fee = state.rollupFees.find((fee) => fee.id === feeId);
        return fee ? fee.name : null;
    },
    // Get fee display name by ID (uses display_name field)
    getRollupFeeDisplayName: (state) => (id) => {
        if (!id) return null;
        const feeId = typeof id === 'string' ? parseInt(id) : id;
        const fee = state.rollupFees.find((fee) => fee.id === feeId);
        return fee ? fee.display_name : null;
    },
    // Get full fee object by ID
    getRollupFeeById: (state) => (id) => {
        if (!id) return null;
        const feeId = typeof id === 'string' ? parseInt(id) : id;
        return state.rollupFees.find((fee) => fee.id === feeId) || null;
    }
};

const actions = {
    [FETCH_ROLLUP_FEES]({ commit }) {
        commit(FETCH_START_ROLLUP_FEES);
        return ApiService.get("/public/rollup-fees")
            .then(({ data }) => {
                // Filter only active fees
                const activeFees = (data.rollupFees || []).filter(
                    (fee) => fee.status === "active"
                );
                commit(FETCH_END_ROLLUP_FEES, activeFees);
                return activeFees;
            })
            .catch((error) => {
                console.error("Error fetching rollup fees:", error);
                commit(FETCH_END_ROLLUP_FEES, []);
                throw new Error(error);
            });
    }
};

const mutations = {
    [FETCH_START_ROLLUP_FEES](state) {
        state.isLoading = true;
    },
    [FETCH_END_ROLLUP_FEES](state, fees) {
        state.rollupFees = fees;
        state.isLoading = false;
        state.lastFetched = new Date().getTime();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

